/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VerifyUnipassPersonResVo } from './VerifyUnipassPersonResVo';
import {
    VerifyUnipassPersonResVoFromJSON,
    VerifyUnipassPersonResVoFromJSONTyped,
    VerifyUnipassPersonResVoToJSON,
    VerifyUnipassPersonResVoToJSONTyped,
} from './VerifyUnipassPersonResVo';

/**
 * 
 * @export
 * @interface ResponseVerifyUnipassPersonResVo
 */
export interface ResponseVerifyUnipassPersonResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseVerifyUnipassPersonResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseVerifyUnipassPersonResVo
     */
    message?: string;
    /**
     * 
     * @type {VerifyUnipassPersonResVo}
     * @memberof ResponseVerifyUnipassPersonResVo
     */
    data?: VerifyUnipassPersonResVo;
}

/**
 * Check if a given object implements the ResponseVerifyUnipassPersonResVo interface.
 */
export function instanceOfResponseVerifyUnipassPersonResVo(value: object): value is ResponseVerifyUnipassPersonResVo {
    return true;
}

export function ResponseVerifyUnipassPersonResVoFromJSON(json: any): ResponseVerifyUnipassPersonResVo {
    return ResponseVerifyUnipassPersonResVoFromJSONTyped(json, false);
}

export function ResponseVerifyUnipassPersonResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseVerifyUnipassPersonResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : VerifyUnipassPersonResVoFromJSON(json['data']),
    };
}

export function ResponseVerifyUnipassPersonResVoToJSON(json: any): ResponseVerifyUnipassPersonResVo {
    return ResponseVerifyUnipassPersonResVoToJSONTyped(json, false);
}

export function ResponseVerifyUnipassPersonResVoToJSONTyped(value?: ResponseVerifyUnipassPersonResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': VerifyUnipassPersonResVoToJSON(value['data']),
    };
}

